"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const context_1 = require("./context");
const MenuList_1 = require("./MenuList");
exports.useFetchMoreOnScroll = (ref) => {
    const { result, pageSize, options, input, paths, variables, hasMore, } = context_1.useOsmosysSelectBoxContext();
    const newVariables = Object.assign(Object.assign({}, variables), { skip: options.length, take: pageSize });
    const isVisible = react_1.useMemo(() => {
        if (!ref.current) {
            return false;
        }
        const { scrollHeight, clientHeight, scrollTop } = ref.current;
        // Menu has no scroll
        if (scrollHeight <= clientHeight) {
            return false;
        }
        const bottomBorder = scrollHeight - clientHeight - MenuList_1.AVAILABLE_DELTA;
        const isVisible = bottomBorder < scrollTop;
        return isVisible;
    }, [
        ref,
        ref.current && ref.current.scrollTop,
        ref.current && ref.current.clientHeight,
        ref.current && ref.current.scrollHeight,
    ]);
    const originalFetchMore = result.fetchMore;
    const fetchMore = react_1.useCallback(() => {
        originalFetchMore({
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) {
                    return prev;
                }
                const newResults = Object.assign(Object.assign({}, prev), { [paths.list]: [...prev[paths.list], ...fetchMoreResult[paths.list]] });
                return newResults;
            },
            variables: newVariables,
        });
    }, [newVariables, paths.list, originalFetchMore]);
    react_1.useEffect(() => {
        if (hasMore && isVisible && result && result.refetch) {
            fetchMore();
        }
    }, [isVisible, input, result, fetchMore]);
    return [fetchMore, isVisible];
};
//# sourceMappingURL=useFetchMoreOnScroll.js.map